let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("diqGF")).then(() => parcelRequire('bjKBT'));